<template>
  <div>

    <div id="box" style="display: none;">
    </div>
    <!-- <div class="box"></div> -->
    <!-- 定部 -->
    <div class="header">
      <div class="header-l" @click="navto(1)">
        <img src="../../../assets/images/手机端/首页手机端/logo拷贝.png" alt="">
      </div>
      <div id="btn" class="header-r" @click="addnav">
        <img src="../../../assets/images/手机端/首页手机端/更多.png" alt="">
      </div>
    </div>


    <div class="main-2">
      <div v-show="show">
        <h3>产品价格详情</h3>

        <div class="sub_title">更低价格，更高享受，每一笔花费都物超所值。</div>
        <swiper class="swiper-container" ref="mySwiper" :options="swiperOption">

          <swiper-slide class="single-price" v-for="(item, index) of priceList" :key="item.index">
            <div class="top" :class="{
              grjc: item.bb == '个人基础版',
              tybg: item.bb == '基础版',
              ptbg: item.bb == '普及版',
              jcbg: item.bb == '高级版',
              jjbg: item.bb == '旗舰版',
              zybg: item.bb == '专属版',
            }">
              <div class="price-content">

                <div class="banben" :style="{ color: item.textColor }">
                  {{ item.bb }}
                </div>
                <!-- <div class="number">
                  {{ item.sl }}
                </div> -->
                <div class="date-price">
                  <p :style="{ color: item.textColor }" style="text-align: center;">
                    <span style="font-size: .7rem">￥</span><span style="font-size: 2rem">{{ item.price }}</span><span
                      style="font-size: .6rem">/{{ item.time ? item.time : '年' }}</span>
                  </p>

                  <!-- 立即购买按钮 -->
                  <div class="buy_btn" :style="{ color: item.color, background: item.bg }"
                    :class="{ trailClass: item.bb == '体验版' }" @click="onClickBuy(item, index)">{{ '立即购买' }}</div>
                  <!-- {{ item.bb == "体验版" ? "元/30天免费" : "元/年" }} -->
                </div>
              </div>
              <!-- <div
                class="start"
                :class="{ startbg: item.bb !== '体验版' }"
                @click="join"
              >
                <span>立即开通</span>
              </div> -->
              <!-- <Modal
                v-model="modal1"
                title="登录提示"
                class-name="case-group"
                @on-ok="ok"
              >
                <p>您还未登录账号</p>
                <div class="dl">
                  <a href="javascript:" @click="toLink('/login')">用户登录</a>
                </div>
              </Modal> -->
            </div>
            <div class="main">
              <div class="min-title">详情</div>
              <ul>
                <!-- <li>
                  <p>软件安装包</p>
                  <span
                    ><img
                      :src="
                        item.rj == true
                          ? require('@/assets/images/true.png')
                          : require('@/assets/images/false.png')
                      "
                      alt=""
                  /></span>
                </li> -->
                <li>
                  <p>已解锁模板</p>
                  <span>{{ item.yjs }}</span>
                </li>
                <!-- <li v-if="item.gj">
                  <p>解锁高级模版权限</p>
                  <span><img :src="
                    item.gj == true
                      ? require('@/assets/images/true.png')
                      : require('@/assets/images/false.png')
                  " alt="" /></span>
                </li> -->
                <li>
                  <p>创建看板</p>
                  <span>{{ item.kb }}</span>
                </li>
                <li>
                  <p>看板密码访问</p>
                  <span><img :src="
                    item.kbpassword == true
                      ? require('@/assets/images/true.png')
                      : require('@/assets/images/false.png')
                  " alt="" /></span>
                </li>
                <li v-if="item.kblj != ''">
                  <p>看板互联</p>
                  <span v-if="item.kblj == ''"><img :src="require('@/assets/images/false.png')" alt="" /></span>
                  <span v-else-if="item.kblj === true"><img :src="require('@/assets/images/true.png')" alt="" /></span>
                  <span v-else>{{ item.kblj }}</span>
                </li>
                <li v-if="item.create != ''">
                  <p>看板PPT</p>
                  <span v-if="item.create == ''">
                    <img :src="require('@/assets/images/false.png')" alt="">
                  </span>
                  <span v-else>{{ item.create }}</span>
                </li>
                <li>
                  <p>文件存储空间</p>
                  <span><img v-if="item.file == true" src="../../../assets/images/true.png" alt="" />
                    <span v-else>{{ item.file }}</span>
                  </span>
                </li>
                <li v-if="item.windowName">
                  <p>自定义系统名称</p>
                  <span><img :src="
                    item.windowName == true
                      ? require('@/assets/images/true.png')
                      : require('@/assets/images/false.png')
                  " alt="" /></span>
                </li>
                <li v-if="item.windowLogo">
                  <p>自定义系统LOGO</p>
                  <span><img :src="
                    item.windowLogo == true
                      ? require('@/assets/images/true.png')
                      : require('@/assets/images/false.png')
                  " alt="" /></span>
                </li>
                <li v-if="item.windowbgi">
                  <p>自定义看板背景</p>
                  <span><img :src="
                    item.windowbgi == true
                      ? require('@/assets/images/true.png')
                      : require('@/assets/images/false.png')
                  " alt="" /></span>
                </li>
                <li v-if="item.data">
                  <p>数据支持</p>
                  <span>{{ item.data }}</span>
                </li>
                <li v-if="item.null1 !== ''">
                  <p></p>
                  <span>{{ item.null1 }}</span>
                </li>
                <li v-if="item.null2 !== ''" id="line">
                  <p></p>
                  <span id="line">{{ item.null2 }}</span>
                </li>
                <li v-if="item.null3 !== ''">
                  <p></p>
                  <span>{{ item.null3 }}</span>
                </li>
                <li>
                  <p>多终端随时使用和访问</p>
                  <span><img :src="
                    item.dzd == true
                      ? require('@/assets/images/true.png')
                      : require('@/assets/images/false.png')
                  " alt="" /></span>
                </li>
                <li>
                  <p>模板，软件升级</p>
                  <span><img :src="
                    item.sj == true
                      ? require('@/assets/images/true.png')
                      : require('@/assets/images/false.png')
                  " alt="" /></span>
                </li>
              </ul>
            </div>
          </swiper-slide>

        </swiper>
      </div>

      <div v-show="!show">

        <h3><i class="el-icon-arrow-left" @click="onClickBack"></i>套餐选择</h3>

        <div class="of1_first">
          <div class="of1_first_left">域</div>
          <div class="of1_first_right">
            <div class="name">域贝数据可视化应用平台</div>
            <div class="time" style="font-size: 12px;">订购日期{{ getTime() }}</div>
          </div>
        </div>

        <div class="of1_second">
          <van-tabs v-model="active" background="transparent">
            <van-tab title="选择套餐">
              <div class="item_group">
                <!-- 采用flex，一行两个元素 -->
                <div v-for="(item, index) of priceList" class="package_item">
                  {{ item.bb }}
                </div>
              </div>
            </van-tab>
            <van-tab title="选择模版">内容 2</van-tab>
          </van-tabs>
        </div>
      </div>

    </div>


    <div class="footer">
      <ul>
        <li @click="goyuzan">
          <p>玉瓒云校园</p>
          <i class="el-icon-arrow-right"></i>
        </li>
        <li @click="subMenu = !subMenu">
          <p>一云看板<i :class="subMenu ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"></i></p>
          <i class="el-icon-arrow-right"></i>
        </li>
        <li v-if="subMenu" style="padding-left: 0.52rem;" @click="$router.push({ path: 'visualizationpage' })">
          <p>产品详情</p>
          <i class="el-icon-arrow-right"></i>
        </li>
        <li v-if="subMenu" style="padding-left: 0.52rem;" @click="$router.push({ path: 'pricepage' })">
          <p>产品定价</p>
          <i class="el-icon-arrow-right"></i>
        </li>
        <li @click="subMenu2 = !subMenu2">
          <p>域贝系列产品<i :class="subMenu2 ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"></i></p>
          <i class="el-icon-arrow-right"></i>
        </li>
        <li v-if="subMenu2" style="padding-left: 0.52rem;" @click="goproductservice">
          <p>域贝证书宝</p>
          <i class="el-icon-arrow-right"></i>
        </li>
        <li v-if="subMenu2" style="padding-left: 0.52rem;" @click="gointegratedpage">
          <p>域贝一体化</p>
          <i class="el-icon-arrow-right"></i>
        </li>
        <li v-if="subMenu2" style="padding-left: 0.52rem;" @click="godate">
          <p>域贝大数据</p>
          <i class="el-icon-arrow-right"></i>
        </li>
      </ul>
      <div class="logn">
        <img src="../../../assets/images/img/首页 手机端/logo.png" alt="">
      </div>
      <div class="dianhua">
        <p><img src="../../../assets/images/img/首页 手机端/电话(1).png" alt="">400-051-0806</p>
      </div>
      <div class="dizhi">
        <p><img src="../../../assets/images/img/首页 手机端/地址.png" alt="">浙江省温州市鹿城区车站大道11号高联大厦1608室</p>
      </div>
      <img @click="iswei" class="erweima" src="../../../assets/images/img/首页手机端/二维码.png" alt="">

      <div class="footer-bottom">
        <p>备案号：浙ICP备13031672</p>
      </div>
    </div>
    <div class="mask"></div>
    <div class="mask"></div>
    <div class="mask1"></div>
    <div class="erweima1">
    </div>
    <div class="ismask" @click.self="qiemask" v-show="ismask">
      <div class="isnav" v-show="isnav">
        <ul>
          <li @click="navto(1)">首页</li>
          <li @click="navto(9)">玉瓒云校园</li>
          <li @click="subMenu = !subMenu">一云看板<i :class="subMenu ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"></i></li>
          <li v-if="subMenu" class="subLi" @click="navto(7)">产品详情</li>
          <li v-if="subMenu" class="subLi" @click="navto(8)">产品定价</li>
          <li @click="subMenu2 = !subMenu2">域贝系列产品<i :class="subMenu2 ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"></i></li>
          <li v-if="subMenu2" class="subLi" @click="navto(2)">域贝证书宝</li>
          <li v-if="subMenu2" class="subLi" @click="navto(3)">域贝大数据</li>
          <li v-if="subMenu2" class="subLi" @click="navto(4)">域贝一体化</li>
          <!-- <li @click="navto(2)">域贝证书宝</li>
          <li @click="navto(3)">域贝大数据</li>
          <li @click="navto(4)">域贝一体化</li> -->
          <li @click="navto(5)">解决方案</li>
          <li @click="navto(6)">关于掌网</li>
        </ul>
      </div>
    </div>
    <div v-show="isweixiang" class="iserweima" @click.stop.self.prevent="isis">
      <img src="../../../assets/images/手机端/电子证书 手机端(1)/lQLPJxZcoFsdZpFnZ7Auu4i-tN-_HgKY00v_AK4A_103_103.png" alt="">
    </div>

    <van-dialog v-model="dialogShow" title="请联系您的专属客服购买">
      <div style="display: flex; justify-content: center;">
        <img src="../../../assets/images/qr-code.png" width="50%" />
      </div>
    </van-dialog>

    <div v-show="callUsDialog" :class="[callUsIndex === 0 ? 'callUs' : 'callUs_2']"
      @click.stop.self.prevent="closeCallUs">
      <div :class="[callUsIndex === 0 ? 'callUs_dialog' : 'callUs_dialog_2']">
        <div class="callUs_title">
          <img class="down" @click="closeCallUs" src="../../../assets/images/手机端/首页手机端/向右箭头备份5.png" alt="">
          <p>联系我们</p>
        </div>
        <div class="bottom_msg">
          <p>您的称呼</p>
          <input :value="name" placeholder="请输入您的称呼" />
          <p>手机号码</p>
          <input :value="phone" placeholder="请输入您的手机号码" />
          <button class="callUs_btn" @click="closeCallUs">提交</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import moment from 'moment'
export default {

  components: {
    swiper,
    swiperSlide
  },

  data() {
    const _self = this
    return {
      active: 0,
      isnav: false,
      ismask: false,
      isweixiang: false,
      callUsDialog: false,
      callUsIndex: 0,
      name: '',
      phone: '',
      activeIndex: 1,
      swiperOption: {
        centeredSlides: true,
        slidesPerView: "auto",
        direction: 'horizontal',
        spaceBetween: 20,
        on: {
          slideChangeTransitionEnd: function () {
            _self.activeIndex = this.activeIndex + 1
          }
        }
      },
      gifIndex: 1,
      gifGif: [
        '',
        '../../../assets/images/手机端/可视化/海量模版.gif',
        '../../../assets/images/手机端/可视化/简易编辑.gif',
        '../../../assets/images/手机端/可视化/看板互联.gif',
        '../../../assets/images/手机端/可视化/自定义分享.gif',
      ],
      gifWord: [
        '',
        '数十款精美模板任你选择，图表、地图、等零代码调整，实现专属于你的个性看板，超多场景适用，同一模版可适配不同场景',
        '后台填充数据，无更多繁琐操作，数据看板自动变化',
        '实时动态更新，海量数据汇总，一键切换看板，多屏分享同时展示，无需等待',
        '“傻瓜式”快速生成一键分享，将精心制作的看板与同事、领导共享，简单又快捷！'
      ],
      show: true,
      dialogShow: false,
      priceList: [
        {
          id: "000",
          bb: "体验版",
          color: '#3A95FE',
          time: "7天",
          bg: '#fff',
          textColor: '#000',
          price: 0.1,
          rj: true,
          yjs: "1个",
          gj: false,
          kb: "1个",
          kbpassword: true,
          kblj: false,
          create: "",
          file: true,
          windowName: false,
          windowLogo: false,
          windowbgi: true,
          data: null,
          null1: "",
          null2: "",
          null3: "",
          dzd: true,
          sj: true,
        },
        {
          id: "001",
          bb: "基础版",
          color: '#61C768',
          textColor: '#fff',
          bg: '#fff',
          price: 98,
          rj: true,
          yjs: "5个",
          gj: false,
          kb: "10个",
          kbpassword: true,
          kblj: '3个',
          create: "3个",
          file: true,
          windowName: true,
          windowLogo: true,
          windowbgi: true,
          data: "自变化300组",
          null1: "",
          null2: "",
          null3: "",
          dzd: true,
          sj: true,
        },
        {
          id: "003",
          bb: "高级版",
          color: '#3C6998',
          textColor: '#fff',
          bg: '#fff',
          price: 298,
          rj: true,
          yjs: "5个",
          gj: true,
          kb: "10个",
          kbpassword: true,
          kblj: true,
          create: "6个",
          file: "双倍空间",
          windowName: true,
          windowLogo: true,
          windowbgi: true,
          data: "数据库实时对接",
          null1: "主流数据库配置接入",
          null2: "支持http接口(get/post请求)\n 调用动态接入",
          null3: "实时数据自动更新",
          dzd: true,
          sj: true,
        },
        {
          id: "004",
          bb: "旗舰版",
          price: 998,
          color: '#0075E6',
          textColor: '#fff',
          bg: '#fff',
          rj: true,
          yjs: "20个",
          gj: true,
          kb: "40个",
          kbpassword: true,
          kblj: true,
          create: "10个",
          file: "三倍空间",
          windowName: true,
          windowLogo: true,
          windowbgi: true,
          data: "数据库实时对接",
          null1: "主流数据库配置接入",
          null2: "支持http接口(get/post请求)\n 调用动态接入",
          null3: "实时数据自动更新",
          dzd: true,
          sj: true,
        },
        {
          id: "005",
          bb: "专属版",
          price: 1998,
          color: '#FFFFFF',
          textColor: '#fff',
          bg: 'linear-gradient(110deg, #0091F1 0%, #005EDC 100%)',
          rj: true,
          yjs: "不限",
          gj: true,
          kb: "不限",
          kbpassword: true,
          kblj: true,
          create: "不限",
          file: "四倍独享空间",
          windowName: true,
          windowLogo: true,
          windowbgi: true,
          data: "数据库实时对接",
          null1: "主流数据库配置接入",
          null2: "支持http接口(get/post请求)\n 调用动态接入",
          null3: "实时数据自动更新",
          dzd: true,
          sj: true,
        },
      ],
      subMenu: false,
      subMenu2: false
    }
  },
  mounted() {
    // console.log(this.$refs.callUs_dialog.style.animation = 'callUs 1s infinite;'
  },
  methods: {
    onClickActive(index) {
      // 获取swiper实例

      this.activeIndex = index
      this.$refs.mySwiper.swiper.slideTo(index - 1)
    },

    iswei() {
      this.isweixiang = true
    },

    getTime() {
      // 以年月日时分秒格式生成时间
      return moment().format("YYYY年MM月DD日 HH:mm:ss");
    },

    onClickBuy() {
      this.dialogShow = true 
      // this.$router.push({ path: 'payment' })
    },

    onClickBack() {
      this.show = true
    },

    isis() {
      this.isweixiang = false
    },
    openCallUs() {
      this.callUsIndex = 0
      this.callUsDialog = true
    },
    closeCallUs() {
      this.callUsIndex = 1
      setTimeout(() => {
        this.callUsDialog = false
      }, 500);
    },
    goVisual() {
      // 回到页面最上面
      this.$router.push({ path: 'visualizationpage' })

    },
    goPrice() {
      document.documentElement.scrollTop = 0
    },
    goproductservice() {
      this.$router.push({ path: 'hoproductservicepage' })
    },
    godate() {
      this.$router.push({ path: 'hodate' })
    },
    goyuzan() {
      window.location.href='http://www.yuzanyun.com'
    },
    gointegratedpage() {
      this.$router.push({ path: 'integratedpage' })
    },
    addnav() {
      this.ismask = !this.ismask
      this.isnav = !this.isnav
    },
    qiemask() {
      console.log(111);
      this.ismask = false
      this.isnav = false
    },
    navto(n) {
      if (n == 1) {
        this.$router.push({ path: 'index' })
      } else if (n == 2) {
        this.$router.push({ path: 'hoproductservicepage' })
      } else if (n == 3) {
        this.$router.push({ path: 'hodate' })

      } else if (n == 4) {
        this.$router.push({ path: 'integratedpage' })
      } else if (n == 5) {
        this.$router.push({ path: 'cooperationpage' })
      } else if (n == 6) {
        this.$router.push({ path: 'aboutpage' })
      } else if (n == 7) {
        this.$router.push({ path: 'visualizationpage' })
      } else if (n == 8) {
        this.ismask = false
        this.isnav = false
      } else if (n == 9) {
        window.location.href='http://www.yuzanyun.com'
      }
    }
  }
}
</script>
<style lang="less" scoped>
a {
  text-decoration: none;
}

/* html {
  font-size: 50px;
} */

/* @media screen and (min-width: 1171px) {
  html {
    font-size: 78.666666667px;
  }
} */
@media screen and (min-width: 320px) {
  html {
    font-size: 21.33333333px;
  }
}

@media screen and (min-width: 360px) {
  html {
    font-size: 24px;
  }
}

@media screen and (min-width: 375px) {
  html {
    font-size: 25px;
  }
}

@media screen and (min-width: 384px) {
  html {
    font-size: 25.6px;
  }
}

@media screen and (min-width: 390px) {
  html {
    font-size: 26px;
  }
}

@media screen and (min-width: 400px) {
  html {
    font-size: 26.66666667px;
  }
}

@media screen and (min-width: 414px) {
  html {
    font-size: 27.6px;
  }
}

@media screen and (min-width: 424px) {
  html {
    font-size: 28.26666667px;
  }
}

@media screen and (min-width: 480px) {
  html {
    font-size: 32px;
  }
}

@media screen and (min-width: 540px) {
  html {
    font-size: 36px;
  }
}

@media screen and (min-width: 720px) {
  html {
    font-size: 48px;
  }
}

@media screen and (min-width: 750px) {
  html {
    font-size: 50px;
  }
}

li {
  list-style: none;
}

p {
  margin: 0;
}

ul {
  margin: 0;
  padding: 0;
}

body {
  min-width: 320px;
  max-width: 750px;
  width: 15rem;
  margin: 0 auto;
  line-height: 1.5;
  font-family: PingFangSC-Regular, sans-serif;
  background: #F2F2F2;
}

.header {
  position: fixed;
  top: 0;
  left: 0;
  height: 2.4rem;
  padding-bottom: .4688rem;
  width: 100%;
  padding-top: .7031rem;
  background-color: #fff;
  z-index: 9999999999;
}

.header-l {
  float: left;
  margin-left: .75rem;
  /* background-image: url('../images/首页 手机端/logo.png'); */
}

.header-l img {
  height: .8rem;
  object-fit: cover;
}

.header-r {
  width: 1.75rem;
  height: 1.375rem;
  float: right;
}

.header-r img {
  width: .62rem;
  height: .5rem;
}



.single-price {
  flex: 0 0 70%;
  background: #fff;
  overflow: hidden;
  border-radius: 4px;
  box-shadow: 0 0 13px rgba(148, 165, 180, 0.27);
  position: relative;

  .top {
    border-radius: 4px;
    height: 12.5rem;
    box-shadow: 0 0 13px rgba(148, 165, 180, 0.27);

    .price-content {
      text-align: center;
      padding: 35px 0 56px;



      .banben {
        color: #fff;
        margin-top: 1.7rem;
        font-size: .88rem;
        font-family: "PingFangSC-Medium", sans-serif;
        margin-bottom: 45px;
        text-align: center;
      }

      .number {
        color: #999999;
        font-size: 22px;
        margin-bottom: 25px;
      }

      .date-price {
        font-size: .7rem;
        font-family: "PingFangSC-Semibold", sans-serif;

        margin-top: 1.6rem;

        span {
          font-size: 2rem;
        }

        .trailClass {
          border: 1px solid #3a95fe;
        }

        .buy_btn {
          margin: 0 auto;
          width: 9rem;
          height: 1.5rem;
          margin-top: 1rem;
          background-color: #fff;
          line-height: 1.5rem;
          border-radius: 4px;
          cursor: pointer;
          font-size: .7rem;

          &:hover {
            transform: translateY(-2px);
          }
        }
      }
    }

    .start {
      text-align: center;
      border-radius: 4px;
      width: 168px;
      height: 46px;
      line-height: 46px;
      margin: 0 auto;
      background: #1989ff;
      cursor: pointer;

      span {
        color: white;
        font-size: 16px;
      }

      .btn-right {
        width: 20px;
        height: 12px;
        line-height: 12px;
      }

      .rightb {
        img {
          &:nth-child(1) {
            display: none;
          }
        }
      }

      &:hover {
        background: #0b72df;
      }
    }

    .startbg {
      transition: all 0.2s;
      background: #ffffff;

      span {
        color: #1989ff;
      }

      &:hover {
        background: #1989ff;

        span {
          color: #fff;
        }

        .rightb {
          img {
            &:nth-child(1) {
              display: block;
            }

            &:nth-child(2) {
              display: none;
            }
          }
        }
      }
    }
  }

  .grjc {
    background: url(../../../assets/images/grjc.png) center/cover;
  }

  .tybg {
    background: url(../../../assets/images/qyjc.jpg) center/cover;
  }

  .ptbg {
    background: url(../../../assets/images/ptbg.png) center/cover;

    .banben {
      color: #fff !important;
    }

    .number {
      color: #fff !important;
    }

    .date-price {
      color: #fff !important;
    }
  }

  .jcbg {
    background: url(../../../assets/images/jcbg.jpg) center/cover;

    .banben {
      color: #fff !important;
    }

    .number {
      color: #fff !important;
    }

    .date-price {
      color: #fff !important;
    }
  }

  .jjbg {
    background: url(../../../assets/images/jjbg.jpg) center/cover;

    .banben {
      color: #fff !important;
    }

    .number {
      color: #fff !important;
    }

    .date-price {
      color: #fff !important;
    }
  }

  .zybg {
    background: url(../../../assets/images/zybg.jpg) center/cover;
  }

  .main {
    height: 23rem;
    width: 100%;

    .min-title {
      font-size: .52rem;
      height: 1.4rem;
      line-height: 1.4rem;
      color: #191919;
      padding: 0 20px;
      text-align: left;
    }

    ul {
      list-style: none;

      li {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 0.5rem;
        height: 1.4rem;
        line-height: 1.4rem;

        p {
          color: #8a94a9;
          font-size: .52rem;
        }

        span {
          color: #191919;
          font-size: .52rem;
          line-height: 0.8rem;
          height: 0.8rem;

          img {
            width: 100%;
          }
        }

        &:nth-child(odd) {
          background-color: #fafafa;
        }
      }

      #line {
        white-space: pre-line;
        height: 2rem;
        line-height: 1rem !important;
        text-align: right;
        text-indent: 10px;
      }
    }
  }

  .bottom {
    padding: 40px 20px;
    border-radius: 0px 0px 4px 4px;

    .product {
      position: relative;

      .min-title {
        color: #999999;
        font-size: 16px;
        margin-bottom: 15px;
      }

      ul {
        list-style: none;

        li {
          display: flex;
          justify-content: space-between;
          align-items: center;

          p {
            color: #191919;
            font-size: 14px;
          }

          span {
            color: #999999;
            font-size: 14px;
          }

          &:not(:last-child) {
            margin-bottom: 15px;
          }
        }
      }
    }
  }

  .jcb {
    .product {
      ul {
        li {
          span {
            color: #6c99c7;
          }
        }
      }
    }
  }

  .jjb {
    .product {
      ul {
        li {
          span {
            color: #0074e5;
          }
        }
      }
    }
  }

  .zyb {
    .product {
      ul {
        li {
          span {
            color: #d1902e;
          }
        }
      }
    }
  }
}





.main-4 {
  margin-bottom: 1.6rem;
  padding: 0 .3125rem;
}

.main-4 h3 {
  margin-top: 0;
  padding-top: 1.6rem;
  font-weight: 600;
  font-family: Arial, PingFangSC-Semibold, sans-serif;
  text-align: center;
  font-size: .72rem;
  color: #2c3e5c !important;
  margin-bottom: .8rem;
}

.main-4 p {
  text-align: center;
  font-size: .52rem;
  color: #8D93AB;
}

.main-4 ul {
  display: flex;
  flex-wrap: wrap;
}

.main-4 ul li img {
  width: 2.3rem;
}

.main-4 ul li {
  text-align: center;
  width: 50%;
  margin-top: 1rem;
  /* margin-bottom: .8rem; */

  .icon {
    width: 80px;
    height: 80px;
    position: relative;
    margin: 0 auto 30px;

    img:first-child {
      position: absolute;
      z-index: 1;
      width: 78px;
      height: 78px;
      left: 0;
      top: 0;
      transition: all 0.3s;
    }

    img:last-child {
      position: absolute;
      z-index: 2;
      width: 60px;
      height: 60px;
      bottom: -5px;
      right: -8px;
      transition: all 0.3s;
    }
  }
}


.main-4 ul li p {
  color: #444444;
  font-size: .52rem;
}

.main-4 ul li div {
  margin-top: .3rem;
  color: #8D93AB;
  font-size: 0.42rem;
}

.main-1 {
  margin-bottom: 1.6rem;
  padding: 0 .3125rem;

}

.main-1 h3 {
  margin-top: 0;
  padding-top: 1.6rem;
  font-weight: 600;
  font-family: Arial, PingFangSC-Semibold, sans-serif;
  text-align: center;
  font-size: .72rem;
  color: #2c3e5c !important;
  margin-bottom: .8rem;
}

.main-1 ul {
  display: flex;
  flex-wrap: wrap;
}

.main-1 ul li img {
  width: 2.3rem;
}

.main-1 ul li {
  text-align: center;
  width: 50%;
  /* margin-bottom: .8rem; */
}

.main-1 ul li:nth-child(1),
.main-1 ul li:nth-child(1) {
  margin-bottom: 2rem;
}

.main-1 ul li p {
  color: #2c3e5c;
  margin-top: 26px;
  font-size: .52rem;
}

.gojia {
  /* margin-bottom: 1.5625rem; */
  // text-align: center;
  width: 100%;
  height: 21.6rem;
  background-size: 100% 100%;
  background-image: url('../../../assets/images/手机端/可视化/为什么选择背景@3x.png');

  padding-top: 1.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  position: relative;

  h3 {
    font-weight: 600;
    font-family: PingFangSC-Regular, sans-serif;
    font-size: .72rem;
    margin-left: .5rem;
    margin: 0;
    // margin-top: 2rem;
    color: #fff;
  }

  p {
    // text-indent: 2em;
    margin-top: .44rem;
    margin-left: 0;
    font-size: .52rem;
    line-height: .85rem;
    color: #C8D1FB;
    opacity: 0.4;
    text-align: justify;
  }

  .circle {
    width: 2.8rem;
    height: 2.8rem;
    background: rgba(71, 79, 116, 0.4);
    border-radius: 50%;
    position: absolute;
    box-sizing: border-box;
    transition-duration: 0.3s;
    transition-timing-function: ease;
    transition-delay: 0s;
    transition-property: all;
    z-index: 10;
    padding: 0.4rem;
    line-height: 0.9rem;
    font-size: .48rem;
    text-align: center;
    color: #C7D1FA;
    opacity: 0.4;




  }


  .circle1_un {
    top: 6.5rem;
    left: 0.9rem;

  }

  .circle1 {
    top: 6.5rem;
    left: 0.9rem;

    background: #567EFF;
    transform: scale(1.4);
    font-size: .48rem !important;
    color: #FFFFFF !important;
    border: 0.3rem solid rgba(71, 79, 116, 1);
  }

  .text1 {
    width: 2.8rem;
    height: 2.8rem;
    position: absolute;
    top: 6.5rem;
    left: 0.9rem;
    font-size: .48rem;
    color: #C7D1FA;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;

    div {
      margin-bottom: 0.2rem;
    }
  }

  .circle2 {
    top: 4.6rem;
    left: 4.2rem;

    &:hover {
      background: #567EFF;
      transform: scale(1.4);
      font-size: .48rem !important;
      color: #FFFFFF !important;
      border: 0.3rem solid rgba(71, 79, 116, 1);
    }
  }

  .text2 {
    width: 2.8rem;
    height: 2.8rem;
    position: absolute;
    top: 4.6rem;
    left: 4.2rem;
    font-size: .48rem;
    color: #C7D1FA;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;

    div {
      margin-bottom: 0.2rem;
    }
  }

  .circle3 {
    top: 4.6rem;
    left: 8.2rem;

    &:hover {
      background: #567EFF;
      transform: scale(1.4);
      font-size: .48rem !important;
      color: #FFFFFF !important;
      border: 0.3rem solid rgba(71, 79, 116, 1);
    }
  }

  .text3 {
    width: 2.8rem;
    height: 2.8rem;
    position: absolute;
    top: 4.6rem;
    left: 8.2rem;
    font-size: .48rem;
    color: #C7D1FA;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;

    div {
      margin-bottom: 0.2rem;
    }
  }

  .circle4 {
    top: 6.5rem;
    left: 11.2rem;

    &:hover {
      background: #567EFF;
      transform: scale(1.4);
      font-size: .48rem !important;
      color: #FFFFFF !important;
      border: 0.3rem solid rgba(71, 79, 116, 1);
    }
  }



  .text4 {
    width: 2.8rem;
    height: 2.8rem;
    position: absolute;
    top: 6.5rem;
    left: 11.2rem;
    font-size: .48rem;
    color: #C7D1FA;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;

    div {
      margin-bottom: 0.2rem;
    }
  }

  .gif {
    width: 100%;
    margin-top: 7rem;
  }

  .bottom {
    margin-top: 0.5rem;
    font-size: 0.52rem;
    color: #eee;
  }

}

.main-2 {
  margin-top: 2.4rem;
  padding-top: 2rem;
  padding-bottom: 0.6rem;
  // padding: 0 .3125rem;

  background: url(../../../assets/images/bg-price.png) top/cover;

  h3 {
    margin-top: 0;
    font-weight: 600;
    font-family: Arial, PingFangSC-Semibold, sans-serif;
    text-align: center;
    font-size: .72rem;
    color: #2c3e5c !important;
    margin-bottom: .8rem;
    position: relative;

    i {
      position: absolute;
      left: 1rem;
    }
  }


  .of1_first {
    width: 100%;
    height: 1.5rem;
    display: flex;
    justify-content: flex-start;
    padding: 0 1rem;

    .of1_first_left {
      width: 2rem;
      height: 2rem;
      line-height: 2rem;
      text-align: center;
      font-size: 16px;
      color: #fff;
      background: #1989ff;
      border-radius: 4px;
    }

    .of1_first_right {
      margin-left: 0.5rem;
      width: 8rem;
      height: 2rem;
      text-align: left;

      .name {
        margin-top: .1rem;
        font-size: .52rem;
        line-height: 1rem;
        color: #191919;
      }

      .time {
        font-size: .42px;
        line-height: .3rem;
        color: #8a94a9;
        margin-top: 7px;
      }
    }
  }

  .of1_second {
    margin-top: 1rem;

    /deep/ .van-tabs__line {
      background-color: rgba(25, 137, 255, 1);
    }

    .item_group {
      width: 100%;
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-template-rows: 1fr 1fr;
    }

    .item {}
  }

  .sub_title {
    font-size: 0.48rem;

    color: #8D93AB;
  }

  .tab {
    margin-top: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;
    padding: 0 1rem;
    font-size: 0.48rem;
    color: #191919;
    cursor: pointer;

    .tab-item {
      &.active {
        font-size: 0.55rem;
        color: rgba(86, 126, 255, 1);
        text-decoration: rgba(86, 126, 255, 1);

        border-bottom: 0.1rem solid rgba(86, 126, 255, 1);
      }
    }


  }

  .swiper-container {
    margin-top: 0.5rem;
    width: 100%;
    height: 100%;

    .swiper-wrapper {
      width: 100%;
      display: flex;
      justify-content: center;


    }
  }

  .swiper-slide {
    width: 80% !important;
    text-align: center;

    height: 100% !important;


  }

  .swiper-slide img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .limit {
    position: absolute;
    top: 5.75rem;
    left: 10.65rem;
    z-index: 10;
  }

}


.main-3 {
  height: 16.6rem;
  padding: 0 .5125rem;
  padding-top: 1.4rem;
  background-size: 100% 100%;

  h3 {
    font-family: Arial, PingFangSC-Semibold, sans-serif;
    font-size: .72rem;
    color: #191919;
    opacity: 0.9;
    font-weight: normal !important;
  }

  .sub_title {
    margin-top: 0.5rem;
    font-size: 0.7rem;
    color: #191919;
    opacity: 0.9;
  }

  p {
    margin-top: 0.5rem;
    font-size: 0.54rem;
    color: #191919;
    opacity: 0.9 !important;
    line-height: 1rem;
  }

  .btn {
    margin-top: .6rem;
  }


}

.main-5 {
  // 一行两个div

  padding: 0 .3125rem;

  display: flex;
  flex-direction: column;
  align-items: center;

  p {
    font-weight: 700;
    color: #191919;
    font-size: .62rem;
    margin-bottom: .5rem;
  }

  .iso {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-evenly;

    .single-ce {
      margin-top: 0.5rem;
      width: 45%;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      background: #fff;
      border-radius: 12px;
      transition: all 0.3s;
      border: 1px solid #fff;
      box-shadow: 0 0 16px rgb(6 27 39 / 14%);
      height: 3.3rem;

      .icon {
        height: 40px;
        line-height: 40px;
        margin-bottom: 10px;
      }

      .text {
        font-size: .52rem;
      }

      &:hover {
        border: 1px solid #1989ff;
        transform: translateY(-2px);
      }
    }
  }


}

.centre {
  padding: 0 .625rem;
}

.centre p {
  margin-top: .625rem;
  font-size: .375rem;
  font-family: PingFangSC-Regular, sans-serif;
  text-align: left;
  text-indent: 2em;
  color: #2c3e5c !important;

}

.centre button {
  width: 3.7188rem;
  height: 1rem;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 2px;
  margin-bottom: 1.25rem;
  margin-top: .625rem;
  font-size: .52rem;
}

.main-2 {
  margin-top: 1.25rem;
  text-align: center;
  margin-bottom: .625rem;
}

.main-2 h3 {
  text-align: center;
  font-weight: normal;
  font-family: Arial, PingFangSC-Semibold, sans-serif;
  color: #2c3e5c !important;
  font-size: .6933rem;
}

.main-2 img {
  margin-bottom: .625rem;
}

.main-6 {

  margin-top: 1rem;
  padding: 0.4125rem;

  .title {
    color: #191919;
    font-size: 30px;
    text-align: center;
    line-height: 30px;
    margin-bottom: 30px;
  }

  .partner-group {
    overflow: hidden;
    position: relative;
    margin-top: 1rem;

    .leftw {
      position: absolute;
      top: 0;
      left: 0;
      width: 80px;
      height: 100%;
      background: linear-gradient(to right, #fff, rgba(255, 255, 255, 0));
      z-index: 2;
    }

    .rightw {
      position: absolute;
      top: 0;
      right: 0;
      width: 80px;
      height: 100%;
      background: linear-gradient(to left, #fff, rgba(255, 255, 255, 0));
      z-index: 2;
    }

    .parner-bg {
      background: url(../../../assets/images/partner.png) 100% / contain repeat-x;
      width: 660vw;
      height: 320px;
      animation: Index-module_scrollToRight_HaAA0 30s infinite linear;
    }
  }
}

.contact {
  margin-top: 80px;
  padding: 0.4135rem;
  background: url(../../../assets/images/bg-contact.png) center/cover;

  .contact-box {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    padding: 13px 0 14px;
    position: relative;

    .left {
      h3 {
        position: absolute;
        color: #444;
        font-size: 0.7rem;
        top: 1rem;
        font-family: "PingFangSC-Semibold", sans-serif;
      }

      button {
        margin-top: 2rem;
      }
    }

    .right {
      width: 60%;

      .contact-img {
        position: relative;

        img {
          width: 100%;
        }

        .poab {
          position: absolute;
          width: 52px;
          height: 60px;
          left: 76%;
          top: 40%;
        }

        .yan {
          position: absolute;
          width: 24px;
          height: 63px;
          left: 91%;
          top: 40%;
        }

        .contact-light {
          position: absolute;
          width: 57px;
          height: 25px;
          left: 10%;
          top: 27%;
        }
      }
    }
  }
}

@keyframes slideshow {
  0% {
    left: 0;
  }

  100% {
    left: -200%;
  }
}

@-webkit-keyframes Index-module_scrollToRight_HaAA0 {
  0% {
    -webkit-transform: translate3d(-50%, 0, 0);
  }

  to {
    -webkit-transform: translateZ(0);
  }
}

@keyframes Index-module_scrollToRight_HaAA0 {
  0% {
    -webkit-transform: translate3d(-50%, 0, 0);
  }

  to {
    -webkit-transform: translateZ(0);
  }
}


.footer {
  position: relative;
  margin-top: 1.6rem;
  padding: 0 .5313rem;
  background-color: #4d73ff;
}

.footer ul {
  margin: 0;
  padding: 0;
}

.footer ul li {
  height: 2rem;
  line-height: 2rem;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.footer ul li p {
  font-size: .52rem;
  color: #fff;
  font-family: PingFangSC-Regular, sans-serif;
}

.el-icon-arrow-right {
  font-size: .56rem;
  margin-right: -0.1rem;
  color: #fff;
}

.logn img {
  width: 5.625rem;
  height: 1.5625rem;
  margin-top: .625rem;
  margin-bottom: .625rem;
  /* width: ; */
  /* background-color: pink; */
}

.dianhua img {
  width: .3281rem;
  height: .3281rem;
  margin-right: .3125rem;
}

.dianhua p {
  font-size: .375rem;
  color: #fff;
  font-family: PingFangSC-Regular, sans-serif;
}

.dizhi {
  margin-top: .3125rem;
  margin-bottom: .625rem;
}

.dizhi img {
  width: .3281rem;
  height: .3281rem;
  margin-right: .3125rem;
}

.dizhi p {
  font-size: .375rem;
  color: #fff;
  font-family: PingFangSC-Regular, sans-serif;
}

.footer-bottom {
  border-top: 1px solid #eee;
  height: 1.4063rem;
}

.footer-bottom {
  padding-top: .3125rem;
  font-size: .375rem;
  color: #fff;
  font-family: PingFangSC-Regular, sans-serif;
}

.aaa {
  display: block !important;
  position: fixed;
  top: 0;
  right: 0;
  width: 45%;
  height: 100%;
  background-color: #fff;
  z-index: 9999999999999;
}

.addbtn {
  width: 4.6rem;
  height: 1.44rem;
  background-color: #5d7bff !important;
  /* 不支持线性的时候显示 */
  background-image: linear-gradient(to right, #5d7bff, #7b9cff);
  border-radius: 0.1rem;
  margin-bottom: 1.25rem;
  margin-right: 0.8rem;
  font-size: .56rem;
  color: #fff !important;
  border: 0;
}

.listiscolor {
  padding: 0 .5625rem;
  padding-top: .3467rem;
  text-align-last: left;
  display: flex;
  margin-bottom: .5333rem;
  height: 4.28rem;
  box-shadow: 2px 2px 5px 2px rgba(95, 92, 92, 0.22) !important;
}

.erweima {
  width: 1.74rem;
  height: 1.74rem;
  position: absolute;
  right: .56rem;
  bottom: 2rem;
}

.mask {
  display: none;
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(0, 0, 0);
  opacity: .2;
}

.maskis {
  display: block;
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(0, 0, 0);
  opacity: .2;
}

.listiscolor {
  padding: 0 1.04rem;
  text-align-last: left;
  display: flex;
  margin-bottom: .3125rem;
  background-color: #fff;
  height: 3.5rem;
  box-shadow: 1px 1px 4px 1px rgba(95, 92, 92, 0.22);
}

.erweima {
  width: 1.74rem;
  height: 1.74rem;
  position: absolute;
  right: .56rem;
  bottom: 2rem;
}

.erweima1 {
  display: none;
  position: fixed;
  bottom: 50%;
  left: 50%;
  transform: translate(-3.6rem, 3.6rem);
}

.erweima1 img {
  width: 7.2rem;
  height: 7.2rem;
}

.ismask {
  position: fixed;
  z-index: 100000 !important;
  top: 0;
  left: 0;
  width: 100%;
  height: 10000px !important;
  background: rgba(0, 0, 0, .2) !important;
}

.isnav {
  position: fixed;
  top: 2.4rem;
  right: 0;
  width: 9rem;
  height: 100%;
  background-color: #fff;
  z-index: 9999;

  ul {
    padding: 0 .48rem;

    li {
      height: 2.12rem;
      line-height: 2.12rem;
      color: #2c3e5c;
      font-size: .56rem;
      font-family: Arial, PingFangSC-Semibold, sans-serif;
      border-bottom: 1px solid #eee;
    }

    .subLi {
      padding-left: .58rem;
    }

    li:nth-child(1) {
      border-top: 1px solid #eee;
    }
  }
}

.iserweima {
  position: fixed;
  // z-index: /;
  top: 0;
  left: 0;
  width: 100%;
  height: 10000px !important;
  background: rgba(0, 0, 0, .2) !important;

  img {
    position: fixed;
    top: calc(50% - 90px);
    left: calc(50% - 90px);
    // width: 7.2rem;
    // height: 7.2rem;
    // left: 50% ;
    // top: 50% ;
    // transform: translate(-50%,-50%);
  }
}

.callUs {
  position: fixed;
  z-index: 100000;
  top: 0;
  left: 0;
  width: 100%;
  height: 10000px !important;
  // background: rgba(0, 0, 0, .0);
  // animation: callUsBG2 .5s forwards;
}

.callUs_2 {
  position: fixed;
  z-index: 100000;
  top: 0;
  left: 0;
  width: 100%;
  height: 10000px !important;
  // background: rgba(0, 0, 0, .3);
  // animation: callUsBG1 .5s forwards;
}

.callUs_dialog {
  position: fixed;
  width: 100%;
  height: 50%;
  bottom: -50%;
  // opacity: 0;
  background: #ffffff;
  border-radius: .2rem .2rem 0 0;
  animation: callUs .5s forwards;
}

.callUs_dialog_2 {
  position: fixed;
  width: 100%;
  height: 50%;
  bottom: 0%;
  // opacity: 0;
  background: #ffffff;
  border-radius: .2rem .2rem 0 0;
  animation: callUs1 .5s forwards;
}

.callUs_title {
  position: relative;
  height: 16%;
  // background: #4d73ff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #f3f3f3;

  .down {
    position: absolute;
    right: .8rem;
    height: .32rem;
  }

  p {
    font-size: .64rem;
    color: #000;
  }
}

.bottom_msg {
  height: 84%;
  padding: 0 .78rem;

  // background: #2c3e5c;
  p {
    margin-top: .6rem;
    font-size: .56rem;
    color: #000;
  }

  input {
    width: 13rem;
    margin-top: .6rem;
    margin-left: .25rem;
    height: 30px;
    font-size: .56rem;
    outline: none;
    border: 0;
    border-bottom: 1px solid #f3f3f3;
  }

  .callUs_btn {
    width: 13rem;
    height: 1.44rem;
    margin-top: 1.2rem;
    margin-left: .25rem;
    background-image: linear-gradient(to right, #5d7bff, #7b9cff);
    border-radius: 0.1rem;
    margin-bottom: 1.25rem;
    font-size: .56rem;
    color: #fff !important;
    border: 0;
  }
}

@keyframes callUs {
  0% {
    bottom: -50%;
  }

  100% {
    bottom: 0%;
  }
}

@keyframes callUs1 {
  0% {
    bottom: 0%;
  }

  100% {
    bottom: -50%;
  }
}

@keyframes callUsBG1 {
  0% {
    background: rgba(0, 0, 0, .3);
  }

  100% {
    background: rgba(0, 0, 0, .0);
  }
}

@keyframes callUsBG2 {
  0% {
    background: rgba(0, 0, 0, .0);
  }

  100% {
    background: rgba(0, 0, 0, .3);
  }
}
</style>
